module.exports = __webpack_public_path__ + "img/star-sharp-half.d1776ab0.svg";